"use client"

import { useState } from "react";
import Image from "next/image";
import ImageLightbox from "./ImageLightbox";

interface ExpandableImageProps {
  src: string;
  alt: string;
  aspectRatio?: number;
  className?: string;
  caption?: string;
  priority?: boolean;
  objectFit?: "object-contain" | "object-cover";
}

export default function ExpandableImage({
  src,
  alt,
  aspectRatio,
  className = "",
  caption,
  priority = false,
  objectFit = "object-contain"
}: ExpandableImageProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <figure className="my-10 group cursor-zoom-in w-full" onClick={() => setIsOpen(true)}>
        <div
          className={`relative overflow-hidden w-full bg-muted/30 ${className}`}
          style={aspectRatio ? { aspectRatio: `${aspectRatio}` } : { aspectRatio: '16/9' }}
        >
          <Image
            src={src}
            alt={alt}
            fill
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 75vw, 50vw"
            className={`w-full h-full ${objectFit} transition-transform duration-700 group-hover:scale-[1.01]`}
            priority={priority}
          />

          {/* Subtle Hover Indicator */}
          <div className="absolute inset-0 bg-black/5 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
            <span className="bg-white/90 px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-black shadow-sm">
              Focus Visual
            </span>
          </div>
        </div>
        {caption && (
          <figcaption className="text-xs text-muted-foreground mt-3 font-medium border-l border-brand pl-3">
            {caption}
          </figcaption>
        )}
      </figure>

      <ImageLightbox
        src={src}
        alt={alt}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
}
